import TranslatedTitleComponent from './TranslatedTitleComponent';

export default TranslatedTitleComponent;
